import withExhibitionsList from 'modules/Exhibition/hoc/withExhibitionsList';
import { ExhibitionsList as ExhibitionsListComponent } from './ExhibitionsList';

export const ExhibitionsList = withExhibitionsList(ExhibitionsListComponent);
